import React, { useEffect, useState } from "react";
import { Box, LinearProgress, Typography } from "@mui/material";
import HeroSection from "../../components/heroSection/hero";
import BgImage from "../../images/background.png";
import EnrolledInterships from "../../components/enrolledInterships/enrolled";
import { verifyToken } from "../../services/auth";
import { useCookies } from "react-cookie";
import LoginDialog from "../../components/dialog/loginDialog";
import { getEnrolledInternships } from "../../services/enroll";

function EnrolledIntershipsPage() {
  const [cookies] = useCookies();
  const [open, setOpen] = useState(false);
  const [loader, setLoder] = useState(true);
  const [enrolledInternships, setEnrolledInternships] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
    verifySession();
  }, []);

  async function getEnrolledData() {
    await getEnrolledInternships(cookies)
      .then((response) => {
        if (response.data.length !== 0) {
          setEnrolledInternships(response.data);
          setLoder(false);
        }
      })
      .catch((error) => console.log(error));
  }

  return (
    <Box>
      <LoginDialog open={open} />
      <HeroSection heroBgImage={BgImage} text={"My Internships"} />
      {loader ? (
        <Box p={10}>
          <LinearProgress sx={{ height: 5, bgcolor: "#229fa4" }} />
        </Box>
      ) : enrolledInternships.length === 0 ? (
        <Typography
          sx={{ fontSize: "40px", height: 150, textAlign: "center", pt: 11 }}
        >
          Not Enrolled In Any Internship
        </Typography>
      ) : (
        <EnrolledInterships enrolledInternships={enrolledInternships} />
      )}
    </Box>
  );

  async function verifySession() {
    await verifyToken(cookies)
      .then((response) => {
        // console.log(response.data)
        if (response.status === 400) setOpen(true);
        else getEnrolledData();
      })
      .catch((error) => console.log(error));
  }
}

export default EnrolledIntershipsPage;
